module.exports = __webpack_public_path__ + "img/login-visual-3.f32f6830.svg";